




import { Component, Vue } from 'vue-property-decorator'

// Helpers
import { Meta } from '@/helpers/decorators'

// Views
import CreateReport from '@/views/report/CreateReport.vue'

@Component({
  components: { CreateReport }
})
export default class Create extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.categories'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
